import { VARIANT_BILLING_TYPE } from './constants/variant-billing-type';

export default function isPwywOption(option) {
  return option?.type === VARIANT_BILLING_TYPE.PAY_WHAT_YOU_WANT || option?.payWhatYouWant === true;
}
